import styled from '@emotion/styled';
import type { FC } from 'react';
import { Center } from '../BasicComponents/MetaComponent';
import { IconExclamation } from '../Icon';

export const DefaultNoDataPlaceholder: FC = () => {
  return (
    <Container>
      <Icon />
      <Text>NO DATA</Text>
    </Container>
  );
};

const Container = styled(Center)`
  position: relative;
  height: 100%;
  flex-direction: column;
  opacity: 0.4;
  z-index: -1;
`;

const Icon = styled(IconExclamation)`
  font-size: 70px;
`;

const Text = styled.div`
  font-size: 2.1rem;
  margin-top: 15px;
`;
